var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selected-payment",class:_vm.methodName},[(_vm.authorizedUrl)?_c('iframe',{staticClass:"iframe-container",attrs:{"src":_vm.iframeURL,"frameborder":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }